import React, { useCallback } from 'react'
import ReactGA from 'react-ga'
import { useSelector, useDispatch } from 'react-redux'
import DashboardTemplate from './components/templates/Dashboard'
import MainContainer from '../../navigation/layouts/Main/MainContainer'
import { useFocusEffect } from '@react-navigation/native'
import {
  getQuickNumbers,
  getEvents
} from '../../redux/dashboard/dashboardActions'
import { dashboardSelector } from '../../redux/dashboard/dashboardSelector'
import { getPreferredLanes } from '../../redux/preferredLane/preferredLanesActions'
import { preferredLaneSelector } from '../../redux/preferredLane/preferredLaneSelector'

ReactGA.pageview('/main/dashboard')

const Dashboard = () => {
  const dispatch = useDispatch()
  const {
    quickNumbers, quickNumbersAlreadyLoaded, loadingQuickNumbers,
    events, eventsAlreadyLoaded, loadingEvents
  } = useSelector(dashboardSelector)
  const { preferredLanes, fethLoading, preferredLanesAlreadyLoaded } = useSelector(preferredLaneSelector)

  useFocusEffect(
    useCallback(() => {
      if (!quickNumbersAlreadyLoaded) {
        dispatch(getQuickNumbers())
      }
    }, [quickNumbersAlreadyLoaded, dispatch])
  )

  useFocusEffect(
    useCallback(() => {
      if (!eventsAlreadyLoaded) {
        dispatch(getEvents())
      }
    }, [eventsAlreadyLoaded, dispatch])
  )

  useFocusEffect(
    useCallback(() => {
      if (!preferredLanesAlreadyLoaded) {
        dispatch(getPreferredLanes())
      }
    }, [preferredLanesAlreadyLoaded, dispatch])
  )

  return (
    <MainContainer title='Dashboard'>
      <DashboardTemplate
        loadingPreferredLanes={fethLoading}
        lanes={preferredLanes}
        loadingQuickNumbers={loadingQuickNumbers}
        quickNumbers={quickNumbers}
        loadingEvents={loadingEvents}
        events={events}
      />
    </MainContainer>
  )
}

export default Dashboard
